export default (that = {}) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.type === 'checkbox'
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: that.type === 'radio'
  },
  {
    title: that.$l('INDEX.order_spec_label_orderGoodsSpecNo') || '产品规格编号',
    field: 'orderGoodsSpecNo',
    width: 150,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_spec_label_orderGoodsSpecName') || '产品规格名称',
    field: 'identifyGoodsName',
    minWidth: 350,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_spec_label_spec') || '规格尺寸',
    field: 'spec',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'spec'
    }
  },
  // {
  //   title:
  //     that.$l('INDEX.order_spec_label_identifyGoodsSpecNo') || '产品规格识别编号',
  //   field: 'identifyGoodsSpecNo',
  //   width: 200,
  //   align: 'left',
  //   headerAlign: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true
  // },
  {
    title: that.$l('INDEX.order_spec_label_spec_inGroupQty') || '规格数量',
    field: 'inGroupQty',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_spec_label_qty') || '数量',
    field: 'qty',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_spec_label_materialDesc') || '面料说明',
    field: 'materialDesc',
    minWidth: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_spec_label_accessoriesDesc') || '辅料说明',
    field: 'accessoriesDesc',
    minWidth: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_spec_label_technologyDesc') || '工艺要求说明',
    field: 'technologyDesc',
    minWidth: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  }
]
